import { render, staticRenderFns } from "./InformacionPedidoBusqueda.vue?vue&type=template&id=18f91848&"
import script from "./InformacionPedidoBusqueda.vue?vue&type=script&lang=js&"
export * from "./InformacionPedidoBusqueda.vue?vue&type=script&lang=js&"
import style0 from "./InformacionPedidoBusqueda.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports